import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
// import './global.css'

import './global_purged.css'
import 'bootstrap/dist/css/bootstrap.min.css'

import './index.css'

// Hide images that fail to load (e.g. external Fachgesellschaft logos returning 503)
// instead of showing a broken-image icon. The 'error' event doesn't bubble, so we
// listen in the capture phase.
if (typeof window !== 'undefined') {
  window.addEventListener(
    'error',
    (e) => {
      const t = e.target
      if (t && t.tagName === 'IMG' && !t.dataset.errorHandled) {
        t.dataset.errorHandled = '1'
        t.style.visibility = 'hidden'
      }
    },
    true
  )
}

ReactDOM.createRoot(
  document.getElementById("root"),
)
.render(
    <App />
)
